import { Card, Col, Row } from 'antd';
import React from 'react';
import { MasterConfigs } from '../../../interfaces/entity';
import MasterComponent from '../../../components/Forms';

const OfferLetterTemplate: React.FC = () => {

    const config: MasterConfigs = {
        api: () => '',
        getFormColumns: () => [
            {
                label: 'Name'
            }
        ],
        getColumns: () => []
    }

    return (
        <MasterComponent config={config} />
    );
};


export default OfferLetterTemplate;